import React from "react";
import { fieldPropTypes } from "redux-form";
import {
  Input,
  ComboBox,
  ToggleButton,
  Checkbox as CheckboxComponent,
  DatePicker,
} from "@components";

export const ToggleField = props => (
  <React.Fragment>
    <ToggleButton
      items={props.items}
      onChange={value => props.input.onChange(value ? "true" : "false")}
    />
    {props.meta.touched &&
      ((props.meta.error && <span className="text-danger">{props.meta.error}</span>) ||
        (props.meta.warning && <span>{props.meta.warning}</span>))}
  </React.Fragment>
);

export const TextareaField = props => (
  <div className="form-group">
    <textarea
      {...props.input}
      disabled={props.disabled}
      className="form-control"
      rows={props.rows || "5"}
      onChange={e => props.input.onChange(e.target.value)}
    >
      {props.input.value || ""}
    </textarea>
    {props.meta.touched &&
      ((props.meta.error && <span className="text-danger">{props.meta.error}</span>) ||
        (props.meta.warning && <span>{props.meta.warning}</span>))}
  </div>
);

export const TextField = props => (
  <React.Fragment>
    <Input
      {...props.input}
      min={props.min}
      max={props.max}
      id={props.id}
      disabled={props.disabled}
      type={props.type}
      autoComplete={props.autocomplete}
      value={props.input.value || ""}
      className={props.className}
      placeholder={props.placeholder}
      onChange={e => props.input.onChange(e.target.value)}
    />
    {props.meta.touched &&
      ((props.meta.error && <span className="text-danger">{props.meta.error}</span>) ||
        (props.meta.warning && <span>{props.meta.warning}</span>))}
  </React.Fragment>
);

export const Dropdown = props => (
  <React.Fragment>
    <ComboBox
      {...props.input}
      value={props.value !== undefined ? props.value : props.input.value}
      onBlur={() => null}
      className={props.className}
      placeholder={props.placeholder}
      options={props.options}
      readOnly={props.disabled}
      id={props.id}
    />
    {props.meta.touched &&
      ((props.meta.error && <span className="text-danger">{props.meta.error}</span>) ||
        (props.meta.warning && <span>{props.meta.warning}</span>))}
  </React.Fragment>
);

export const Checkbox = props => {
  return (
    <React.Fragment>
      <CheckboxComponent
        {...props.input}
        checked={props.input.value}
        label={props.label}
        className={props.className}
        disabled={props.disabled}
      />
      {props.meta.touched &&
        ((props.meta.error && <span className="text-danger">{props.meta.error}</span>) ||
          (props.meta.warning && <span>{props.meta.warning}</span>))}
    </React.Fragment>
  );
};

export const DatePickerFormWrapper = props => (
  <React.Fragment>
    <DatePicker
      {...props.input}
      {...(props.customProps || {})}
      className={props.className}
      disabled={props.disabled}
      value={props.input.value}
      onChange={e => {
        props.input.onChange(e || null);
      }}
    />
    {props.meta.touched &&
      ((props.meta.error && <span className="text-danger">{props.meta.error}</span>) ||
        (props.meta.warning && <span>{props.meta.warning}</span>))}
  </React.Fragment>
);

Dropdown.propTypes = fieldPropTypes;
